import { useState, useEffect } from "react";

/**
 * The `booking-form` MFE (see `BookingFormElement.tsx`) always renders its
 * mobile layout, regardless of the embedding page's viewport, so layout
 * decisions must never report "above threshold" (desktop) for it.
 */
const isBookingFormMfe = (): boolean =>
  typeof document !== "undefined" && document.querySelector("booking-form") !== null;

const useWindowWidthThreshold = (threshold: number) => {
  const [isAboveThreshold, setIsAboveThreshold] = useState(() => !isBookingFormMfe() && window.innerWidth > threshold);

  useEffect(() => {
    if (isBookingFormMfe()) {
      setIsAboveThreshold(false);
      return;
    }
    setIsAboveThreshold(false);
    const handleResize = () => {
      setIsAboveThreshold(window.innerWidth > threshold);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [threshold]);
  return isAboveThreshold;
};

export default useWindowWidthThreshold;
